import { get, post, put, del } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const leadActivityService = {
  /**
   * Create a new activity for a lead
   */
  createActivity: async (leadId, activityData) => {
    try {
      const response = await post(`${API_ENDPOINTS.CRM.LEADS}/${leadId}/activities`, activityData);

      if (response && response.responseCode === 201) {
        return {
          success: true,
          activity: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to create activity'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to create activity'
      };
    }
  },

  /**
   * Get all activities for a specific lead with filters, search, and sorting
   */
  getLeadActivities: async (leadId, filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (filters.type && filters.type !== 'all') queryParams.append('type', filters.type);
      if (filters.outcome) queryParams.append('outcome', filters.outcome);
      if (filters.priority) queryParams.append('priority', filters.priority);
      if (filters.startDate) queryParams.append('startDate', filters.startDate);
      if (filters.endDate) queryParams.append('endDate', filters.endDate);
      if (filters.search) queryParams.append('search', filters.search);
      if (filters.sortBy) queryParams.append('sortBy', filters.sortBy);
      if (filters.sortOrder) queryParams.append('sortOrder', filters.sortOrder);
      if (filters.page) queryParams.append('page', filters.page);
      if (filters.limit) queryParams.append('limit', filters.limit);

      const url = queryParams.toString() 
        ? `${API_ENDPOINTS.CRM.LEADS}/${leadId}/activities?${queryParams.toString()}`
        : `${API_ENDPOINTS.CRM.LEADS}/${leadId}/activities`;

      const response = await get(url);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          activities: response.data.activities || [],
          pagination: response.data.pagination || {}
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve activities',
          activities: []
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to retrieve activities',
        activities: []
      };
    }
  },

  /**
   * Get activity by ID
   */
  getActivityById: async (activityId) => {
    try {
      const response = await get(`${API_ENDPOINTS.CRM.ACTIVITIES}/${activityId}`);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          activity: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve activity'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to retrieve activity'
      };
    }
  },

  /**
   * Update activity
   */
  updateActivity: async (activityId, activityData) => {
    try {
      const response = await put(`${API_ENDPOINTS.CRM.ACTIVITIES}/${activityId}`, activityData);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          activity: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to update activity'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to update activity'
      };
    }
  },

  /**
   * Delete activity
   */
  deleteActivity: async (activityId) => {
    try {
      const response = await del(`${API_ENDPOINTS.CRM.ACTIVITIES}/${activityId}`);

      if (response && response.responseCode === 200) {
        return {
          success: true
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to delete activity'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to delete activity'
      };
    }
  },

  /**
   * Get all activities (across all leads) with filters, search, and sorting
   */
  getAllActivities: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (filters.type && filters.type !== 'all') queryParams.append('type', filters.type);
      if (filters.leadId) queryParams.append('leadId', filters.leadId);
      if (filters.performedBy) queryParams.append('performedBy', filters.performedBy);
      if (filters.outcome) queryParams.append('outcome', filters.outcome);
      if (filters.priority) queryParams.append('priority', filters.priority);
      if (filters.startDate) queryParams.append('startDate', filters.startDate);
      if (filters.endDate) queryParams.append('endDate', filters.endDate);
      if (filters.search) queryParams.append('search', filters.search);
      if (filters.sortBy) queryParams.append('sortBy', filters.sortBy);
      if (filters.sortOrder) queryParams.append('sortOrder', filters.sortOrder);
      if (filters.page) queryParams.append('page', filters.page);
      if (filters.limit) queryParams.append('limit', filters.limit);

      const url = queryParams.toString() 
        ? `${API_ENDPOINTS.CRM.ACTIVITIES}?${queryParams.toString()}`
        : API_ENDPOINTS.CRM.ACTIVITIES;

      const response = await get(url);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          activities: response.data.activities || [],
          pagination: response.data.pagination || {}
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve activities',
          activities: []
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to retrieve activities',
        activities: []
      };
    }
  }
};

export default leadActivityService;

